import { Controller } from "stimulus"

export default class extends Controller {
  static get targets() {
    return [
      // Elements within the product selection container.
      "form",
      "box",
      "label",
      "price",
      "orderType", // Used to set delivery fee or not.

      // Elements within the checkout sidebar container.
      "products",
      "subtotal",
      "tax",
      "total",
      "submit",

      // The counts of each product. Used to make sure they're not all zero.
      "count",

      // The select input of each product.
      "select",

      // Used to show a count validation error.
      "error"
    ]
  }

  connect() {
    this.handleChange()
  }

  submit(ev) {
    var valid = false
    this.countTargets.forEach(function(target) {
      if (target.selected && parseInt(target.value) !== 0) {
        valid = true
      }
    })

    if (!valid) {
      this.errorTarget.classList.remove("hidden")
      ev.preventDefault()
      return false
    }
  }

  /**
   * handleChange handles the radio button selection event in order to update
   * the form's appearance, and to to update the product selection view in the
   * sidebar.
   */
  handleChange() {
    this.errorTarget.classList.add("hidden")
    return
    // var baseCost = 0
    // var labels = []

    // this.selectTargets.forEach((selectTarget, i) => {
    //   const productCount = parseInt(selectTarget.value)

    //   if (productCount > 0) {
    //     const unitCost = parseFloat(this.priceTargets[i].innerText.substr(1))
    //     baseCost += (unitCost * productCount)
    //     labels.push(`${this.labelTargets[i].innerText} × ${productCount}`)
    //   }
    // })

    // // TODO If we add delivery back in, include a delivery fee.
    // const hstCost = (baseCost * 0.13)
    // const totalCost = (baseCost + hstCost)

    // this.productsTarget.innerText = labels.join("\n")

    // this.subtotalTarget.innerText = "$" + baseCost.toFixed(2)
    // this.taxTarget.innerText = "$" + hstCost.toFixed(2)
    // this.totalTarget.innerText = "$" + totalCost.toFixed(2)

    // this.submitTarget.value = `Continue – $${totalCost.toFixed(2)}`
  }
}
